import type { Contract, ContractReplacement, ProjectFundingContract } from '../types';
import { contractOutstandingAmount, contractPaidInAmount } from './contractFrameTotals';

/** A scoped ÄTA stores cumulative balances, but its list row shows the change.
 * Subtract the preceding agreement's value so carried funding is not presented
 * as a deposit for the ÄTA. Confirmed receipts take precedence over legacy balances. */
export function contractListFunding(
  contract: Contract,
  funding?: ProjectFundingContract,
  draft?: Pick<ContractReplacement, 'retainedFundingOre' | 'additionalPaymentOre'> | null
): { paidAmount: number; remainingAmount: number } {
  const paidAmount = draft ? draft.retainedFundingOre / 100 : Number(contractPaidInAmount(contract, funding));
  if (!contract.stageVariation) {
    return {
      paidAmount,
      remainingAmount: draft ? draft.additionalPaymentOre / 100 : contractOutstandingAmount(contract, funding)
    };
  }

  // Calculate in öre, including ROT changes, and cap funding at the ÄTA value.
  // A price reduction requires no new deposit.
  const deltaOre = contract.stageVariation.afterRotDeltaOre;
  const requirementOre = Math.max(0, deltaOre);
  const precedingAmountOre = Math.max(0, Math.round(Number(contract.afterRotAmount) * 100) - deltaOre);
  const fundedOre = Math.min(requirementOre, Math.max(0, Math.round(paidAmount * 100) - precedingAmountOre));
  return { paidAmount: fundedOre / 100, remainingAmount: (requirementOre - fundedOre) / 100 };
}
